module.exports = __webpack_public_path__ + "img/102ne.8b03b981.svg";